/*FORM FOOTER*/
(function () {
  const TARGET_ID = 'ASWNXb05vZUlSa0VtS__forms_inline_XMqk7a';
  const STYLE_ID = 'custom-shopify-forms-inline-layout';

  function getTargetEmbed() {
    const container = document.getElementById(TARGET_ID);
    if (!container) return null;
    return container.querySelector('shopify-forms-embed');
  }

  function injectIntoRoot(root) {
    if (!root || root.getElementById(STYLE_ID)) return false;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      ._gridItemContent_1q1d2_257,
      ._formContainer_1q1d2_30,
      ._inline_1q1d2_47 {
        width: 100% !important;
        max-width: 100% !important;
      }

      ._formFieldset_cit2d_82 {
        display: grid !important;
        grid-template-columns: 2fr 2fr 1fr !important;
        width: 95% !important;
        max-width: 90% !important;
        gap: 5px !important;
        align-items: stretch !important;
      }

      ._formFieldset_cit2d_82 > div[style],
      ._formFieldset_cit2d_82 > ._formFieldContainer_1mxsl_5,
      ._formFieldset_cit2d_82 > ._formSubmitButton_cit2d_96 {
        min-width: 0 !important;
        width: 100% !important;
        margin: 0 !important;
        box-sizing: border-box !important;
      }


      ._formFieldset_cit2d_82 > div[style] {
        display: none !important;
      }

      ._formFieldset_cit2d_82 ._formInputField_nag3b_7,
      ._formFieldset_cit2d_82 ._formSubmitButton_cit2d_96 {
        width: 100% !important;
        height: 100% !important;
        box-sizing: border-box !important;
        border-radius: 50px !important;
        font-weight: bold !important;
      }

      ._formFieldContainer_1mxsl_5 {
        position: relative !important;
      }

      ._formDisclaimer_cit2d_38 {
        width: 100% !important;
        max-width: 100% !important;
        margin-top: 12px !important;
      }
        ._formFieldContainer_1mxsl_5 input {
  background-color: #cfccdd !important;
  border-radius: 50px !important;

  ._formFieldset_cit2d_82 div {
  border-radius: 50px !important
  }
}
._gridItem_1q1d2_172._gridItemContent_1q1d2_257 {
padding-bottom: 0px !important;
}
._formContainer_1q1d2_30._grid_1q1d2_148._noImage_1q1d2_161 {
min-height: 0px !important;
}

._copyToClipboardButton_bboux_2 {
background-color: white !important;
}
._copyToClipboardButton_bboux_2:hover {
background-color: #81b9f3 !important;
}
._copyToClipboardButton_bboux_2 span {
color: #231664 !important;
}
._copyToClipboardButton_bboux_2 span:hover {
color: #231664 !important;
}
    `;
    root.appendChild(style);
    return true;
  }

  function tryApply() {
    const embed = getTargetEmbed();
    if (!embed || !embed.shadowRoot) return false;
    return injectIntoRoot(embed.shadowRoot);
  }

  function attachObservers() {
    const embed = getTargetEmbed();
    if (!embed) return;

    if (!embed.__shopifyFormsObserverAttached) {
      const observer = new MutationObserver(() => {
        tryApply();
      });
      observer.observe(embed, { childList: true, subtree: true });
      embed.__shopifyFormsObserverAttached = true;
    }

    if (embed.shadowRoot && !embed.shadowRoot.__shopifyFormsObserverAttached) {
      const shadowObserver = new MutationObserver(() => {
        tryApply();
      });
      shadowObserver.observe(embed.shadowRoot, { childList: true, subtree: true });
      embed.shadowRoot.__shopifyFormsObserverAttached = true;
    }
  }

  function boot() {
    let attempts = 0;
    const maxAttempts = 60;

    const interval = setInterval(() => {
      attempts++;

      tryApply();
      attachObservers();

      const embed = getTargetEmbed();
      if ((embed && embed.shadowRoot) || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/*END FOOTER FORM*/